<template>
  <category-page :resource-params="resourceParams" :parent="parent" />
</template>

<script>
/* List resources by classroom management
 *
 * @parent:
 * @requests: /public/v1/category
 * @events:
 * @props:
 * @components: CategoryPage
 * @methods:
 */

import CategoryPage from '~/components/category/CategoryPage.vue';

const root = 'classroom-management';

export default {
  name: 'ClassroomManagement',
  components: {
    CategoryPage,
  },
  async asyncData({ app, store, route, params, error }) {
    const data = {};
    const loggedInUser = store.getters.loggedInUser;

    // For the resource list query
    data.resourceParams = {
      category: params.slug,
      perPage: 32,
      root: root + '-' + app.i18n.locale,
    };

    // Auto-select user's year level(s) when making a query
    if (loggedInUser && loggedInUser.year_levels) {
      data.resourceParams.year_levels = loggedInUser.year_levels;
    }

    try {
      // Load the category title, description and list of sub-categories
      const category = await store.dispatch('loadCategory', {
        category: params.slug,
        root: root + '-' + app.i18n.locale,
        link: route.path,
      });

      // For meta fields
      data.title = category.name + ' Teaching Resources';
      data.category = category;
    } catch (err) {
      // No page matching this route
      error({ statusCode: 404, message: err.message, path: route.path });
    }

    return data;
  },
  data() {
    return {
      title:
        this.$i18n.locale === 'us'
          ? 'Classroom management'
          : 'Teaching Resources by classroom management',
      category: {},
      parent: {
        link: '/' + this.$i18n.locale + '/classroom-management/',
        name: 'Classroom Management',
      },
      resourceParams: {},
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: this.$metaPropertiesCategory(this.category),
      link: this.$hrefLangsResource(
        this.category.linked,
        this.category.link,
        this.$i18n.locale,
        this.$route
      ),
    };
  },
};
</script>
